const translations = {
  loading: 'Loading...',
  page_title: 'Inventory',
  integration: 'Integration',
  importer: 'Importer',
  manual: 'Manual',

  source: 'Source',
  total: 'Total',
  percentage: 'Percentage',
  impressions: 'Impressions',
  views: 'Views',
  featured: 'Featured',
  conversions: 'Conversions',
  range: 'Range',
  no_data_for_this_period: 'No data for this period',
  call: 'Call',

  ['pricing.sale_price']: 'Sale Price',
  ['pricing.suggested_price']: 'Suggested Price',
  ['pricing.internet_price']: 'Internet Price',
  ['pricing.on_sale_price']: 'On Sale Price',
  ['pricing.market_price']: 'Market Price',

  add_vehicle: 'Add vehicle',
  vehicle_pricing: 'Pricing Insights',
  new_vehicle: 'New vehicle',
  enter_the_vin:
    "Enter the VIN to get manufacturer information. In case you don't have it you can skip this step.",
  pricing_enter_the_vin: 'Enter the VIN to get pricing insights',
  empty_vin_info: 'We could not retrieve information from the VIN that you provided',
  invalid_vin: 'The VIN format is incorrect',
  repeated_vin: 'This VIN is already in use',
  basic_info: 'Basic info',
  vin_info_changed: "The VIN doesn't match the data entered",
  vin_value_changed: 'This VIN value differs from the original one',

  vin_warning_title: 'VIN Inconsistency',
  vin_warning_body: 'The original VIN data was mannually modified, do you want to proceed anyway?',

  tooltip_enter_vin: 'Enter the VIN to get manufacturer information',
  select_placeholder: 'Select',
  year: 'Year',
  year_required: 'Year is required',
  make_required: 'Make is required',
  make_model_required: 'Model is required',
  condition_required: 'Condition is required',
  type_required: 'Type is required',
  make: 'Make',
  model: 'Model',
  trim: 'Trim',
  xls: 'XLS',
  condition: 'Condition',
  new: 'New',
  used: 'Used',
  type: 'Type',
  mileage: 'Mileage',
  notes: 'Notes',
  color: 'Color',
  ext_color: 'Ext. Color',
  exterior_color: 'Exterior Color',
  int_color: 'Int. Color',
  interior_color: 'Interior Color',
  reception_date: 'Reception date',
  is_title_in_dealer: 'Is title in dealer',
  title_in_dealer: 'Title in dealer',
  plate_number: 'Plate #',
  tag_number: 'Tag #',
  tag_number_expiration_date: 'Tag # exp. date',
  is_tune_up: 'Tune up',
  labels: 'Labels',
  dealer: 'Dealer',
  pledged: 'Pledged',
  location: 'Location',
  age: 'Age',
  optional_info: 'Details',
  stock_number: 'Stock number',
  doors: 'Doors',
  engine: 'Engine',
  engine_placeholder: '1.8',
  transmission: 'Transmission',
  automatic: 'Automatic',
  mpg_city: 'MPG City',
  mpg_highway: 'MPG Highway',
  media: 'Media',
  price_step: 'Price & Costs',
  marketing: 'Marketing',
  sale_price: 'Sale price',
  market_price: 'Market price',
  suggested_price: 'Suggested price',
  cost: 'Cost',
  terms_of_sale: 'Terms of sale',
  negotiable: 'Negotiable',
  firm: 'Firm',
  title: 'Title',
  if_empty: 'If empty will show “Year + Make + Model + Trim”',
  description: 'Description',
  featured_external: 'Featured on external pages',
  show_price_external: 'Show price on external pages',
  allow_alliances: 'Allow alliances to see and search this vehicle',
  go_back: 'Go back',
  discard_changes: 'Discard changes',
  all_changes_lost: 'All changes will be lost, this action cannot be undone.',
  columns: 'Columns',

  expire: 'Expire',
  cancel: 'Cancel',
  other: 'Other',
  sold: 'Sold',
  for_what_reason: 'For what reason do you want the vehicle to be expired?',
  at_what_price: 'At what price was it sold?',
  price: 'Price',

  name_lastname: 'Nombe Apellido',
  status: 'Status',
  customer_info: 'Customer Info',
  name: 'Name',
  last_name: 'Last Name',
  phone: 'Phone',
  mobile_phone: 'Mobile phone',
  email: 'Email',
  social_security: 'Social Security',
  birth_date: 'Birth date',
  license: 'License',
  license_plate: 'License Plate',
  gender: 'Gender',
  zip_code: 'ZIP code',
  address: 'Address',
  city: 'City',
  vehicle: 'Vehicle',

  this_vehicle_no_leads: 'This vehicle has no leads yet',
  do_something: 'Do something!',

  upload_error: 'Upload Error',
  file_uploaded: '{{file}} file uploaded successfully.',
  file_uploaded_error: '{{file}} file upload failed.',
  file_uploaded_removed: 'The item was removed.',
  file_upload_limit_reached: "You've reached the limit of {{limit}} media files per vehicle",
  add_media: 'Add media',
  click_or_drag: 'Click or drag file to this area to upload',
  you_can_reorder: 'You can reorder the images by draggin them to the desired location',

  vehicle_action: 'Vehicle Action',

  copy_vin: 'Copy VIN',
  vin_copied: 'VIN successfully copied!',
  start_deal: 'Start a deal',
  stock_number_hash: 'Stock #',
  alliances: 'Alliances',
  visibility: 'Visibility',
  visibility_public: 'Public',
  visibility_internal: 'Internal',
  visible: 'Visible',
  not_visible: 'Not visible',
  search_by_make_model_vin: 'Search by make, model or VIN',
  search_vehicle: 'Search vehicle',
  select_vehicles: 'Select vehicles',
  there_are_no_vehicles: 'There are no vehicles that match your search',
  choose_ohter_filters: 'Choose other filters and try again',
  vehicle_expired: 'The vehicle has been expired',
  vehicle_expired_plural: 'The vehicles have been expired',
  set_featured: 'Set featured',
  vehicle_featured: 'The vehicle have been featured',
  vehicle_featured_plural: 'The vehicle have been featured',
  vehicle_on_sale: 'The vehicle is on sale',
  vehicle_on_sale_plural: 'The vehicles are on sale',
  vehicle_discount_plural: 'The vehicles discount was set',
  vehicle_down_price_plural: 'The vehicles down price was set',
  vehicle_price_drop_plural: 'The vehicles price drop was set',
  vehicle_discount: 'The vehicle discount was set',
  down_price: 'Down price',
  price_drop: 'Price drop',
  vehicles_found_n: '<bold>{{n}} vehicles</bold> found',
  form_generated: 'Form generated successfully',
  images: 'Images',
  activate: 'Activate',
  are_you_sure_expire_plural: 'Are you sure you want to expire these vehicles?',
  vehicles_expired: 'The vehicles have been expired',
  vehicles_expired_error: 'Expiring vehicles failed',
  alliance_visibility_on: 'Alliance visibility ON',
  vehicles_visibles: 'The vehicles are visible to alliances',
  vehicles_visibles_error: 'Changing visibility to alliances failed',
  alliance_visibility_off: 'Alliance visibility OFF',
  vehicles_not_visibles: 'The vehicles are not visible to alliances',
  vehicles_not_visibles_error: 'Changing visibility to alliances failed',
  import_stock_photos: 'Import stock photos',
  import_stock_photos_description:
    'Stock photos will be imported for the selected vehicles that have a VIN and no photos or videos.',

  expiration_date: 'Expiration date',
  expiration_date_placeholder: 'Expiration date',
  invalid_expiration_date: 'Invalid expiration date',
  expiration_date_infinite: 'Enable it without setting an expiration date',

  on_sale: 'On sale',
  discount_coupon: 'Discount coupon',
  coupon_amount: 'Coupon amount',
  amount_placeholder: 'Amount',
  invalid_amount: 'Invalid amount',

  vehicle_updated: 'The vehicle has been updated successfully.',
  vehicle_added: 'The vehicle has been added successfully.',
  vehicle_updated_not_media:
    'Vehicle data successfully updated but media failed to upload, please try again.',

  bulk_edit_error: 'Bulk edit failed',

  media_source: 'Media source',
  media_source_description:
    'You can add image or video files from your computer or add links to YouTube videos.',
  add_file: 'Add file',
  youtube_link: 'YouTube link',
  enter_video_url: 'Enter the URL',
  youtube_url_error: 'The URL could not be processed. Please verify that it is a valid URL.',
  already_has_video_error: 'The vehicle already has one video uploaded',
  does_not_have_video_feature:
    'Video upload is not available on your current plan, please get in touch to upgrade your plan. In the mean time, you can still add pictures of the vehicle.',
  not_supported: 'Video upload',

  edit_vehicle: 'Edit vehicle',
  view_details: 'View details',
  analytics: 'Analytics',
  contacts: 'Contacts',
  download_daco: 'Download DACO',
  download_warranty: 'Download Warranty & Conditions',
  download_blank_daco: 'Download Blank DACO',
  download_blank_warranty: 'Download Blank Warranty & Conditions',
  download_qr: 'Download QR Form',
  are_you_sure_to_activate: 'Are you sure you want activate this vehicle?',
  are_you_sure_to_activate_plural: 'Are you sure you want activate these vehicle?',
  vehicle_activated: 'The vehicle has been activated',
  vehicle_activated_plural: 'The vehicles have been activated',
  expiring_failed: 'Expiring vehicle failed',
  visibility_changed: 'The vehicle visibility have been changed',
  visibility_failed: 'Changing visibility vehicle failed',

  filter_expiring: 'Expiring next 30 days',
  filter_expiring_short: 'Exp. next 30 days',
  filter_featured: 'Featured',
  filter_ongoing_deal: 'Ongoing deal',
  filter_no_vin: 'Without VIN',
  filter_no_price: 'Without price',
  filter_no_pictures: 'Without pictures',
  vehicles: 'vehicles',
  days: 'days',
  day: 'day',
  today: 'Today',
  yesterday: 'Yesterday',

  sort_ascending: 'Click to sort ascending',
  sort_descending: 'Click to sort descending',
  sort_custom: 'Custom',

  some_vehicle_has_open_deal:
    "The vehicles can't be expire because one or more of the selected vehicles has an open deal.",
  vehicle_has_open_deal: "The vehicle can't be expire because it has an open deal.",
  go_to_deal: 'Go to deal',

  vehicle_already_active: 'There is already an active vehicle with this VIN.',

  available: 'Available',
  in_deal: 'In deal',

  // Filter labels for AppliedFiltersBar
  year_from: 'Year from',
  year_to: 'Year to',
  price_from: 'Price from',
  price_to: 'Price to',
  mileage_from: 'Mileage from',
  mileage_to: 'Mileage to',
  deal_status: 'Deal status',

  // Pricing insights modal
  pricing_insights: 'Pricing insights',
  median: 'Median',
  average: 'Average',
  based_on_vehicles: 'Based on {{count}} vehicles',
  search: 'Search',
  new_search: 'New search',
  close: 'Close',
  no_pricing_data_available: 'No pricing data available',

  activity_log: 'Activity log',
};

export default translations;
